/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { KokpitEnviromentType } from './KokpitEnviromentType';
import {
    KokpitEnviromentTypeFromJSON,
    KokpitEnviromentTypeFromJSONTyped,
    KokpitEnviromentTypeToJSON,
} from './KokpitEnviromentType';

/**
 * 
 * @export
 * @interface KokpitEnvironmentDto
 */
export interface KokpitEnvironmentDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitEnvironmentDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitEnvironmentDto
     */
    tenantId?: number | null;
    /**
     * İsim
     * @type {string}
     * @memberof KokpitEnvironmentDto
     */
    name?: string | null;
    /**
     * Kokpit arayüz Urlsi
     * @type {string}
     * @memberof KokpitEnvironmentDto
     */
    url?: string | null;
    /**
     * Kokpit Api Urlsi
     * @type {string}
     * @memberof KokpitEnvironmentDto
     */
    apiUrl?: string | null;
    /**
     * Kokpit Api için kullanılacak token (Kokpit customerId 1 olan (tüm müşterileir görecek))
     * @type {string}
     * @memberof KokpitEnvironmentDto
     */
    token?: string | null;
    /**
     * 
     * @type {KokpitEnviromentType}
     * @memberof KokpitEnvironmentDto
     */
    type?: KokpitEnviromentType;
    /**
     * Kokpit lisans anahtarı
     * @type {string}
     * @memberof KokpitEnvironmentDto
     */
    licenseKey?: string | null;
}

/**
 * Check if a given object implements the KokpitEnvironmentDto interface.
 */
export function instanceOfKokpitEnvironmentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitEnvironmentDtoFromJSON(json: any): KokpitEnvironmentDto {
    return KokpitEnvironmentDtoFromJSONTyped(json, false);
}

export function KokpitEnvironmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitEnvironmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'apiUrl': !exists(json, 'apiUrl') ? undefined : json['apiUrl'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'type': !exists(json, 'type') ? undefined : KokpitEnviromentTypeFromJSON(json['type']),
        'licenseKey': !exists(json, 'licenseKey') ? undefined : json['licenseKey'],
    };
}

export function KokpitEnvironmentDtoToJSON(value?: KokpitEnvironmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenantId': value.tenantId,
        'name': value.name,
        'url': value.url,
        'apiUrl': value.apiUrl,
        'token': value.token,
        'type': KokpitEnviromentTypeToJSON(value.type),
        'licenseKey': value.licenseKey,
    };
}

